import { render, staticRenderFns } from "./SetupDetails.vue?vue&type=template&id=f6e4133e&"
import script from "./SetupDetails.vue?vue&type=script&lang=js&"
export * from "./SetupDetails.vue?vue&type=script&lang=js&"
import style0 from "./SetupDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports